import { IconBaseProps } from 'react-icons';
import * as FI from 'react-icons/fi';
import { RiEyeLine, RiEyeCloseLine, RiDeleteBinLine } from 'react-icons/ri';
import { AiFillWarning } from 'react-icons/ai';

const allIcons = { ...FI, RiEyeCloseLine, RiEyeLine, RiDeleteBinLine, AiFillWarning };
export type IconName = keyof typeof allIcons;

type IconProps = {
  name: IconName;
  className?: string;
} & IconBaseProps;

export function Icon(props: IconProps): React.ReactElement {
  const { name, className, ...rest } = { ...props };

  const Tag = allIcons[name];

  return className ? (
    <span className={className}>
      <Tag {...rest} />
    </span>
  ) : (
    <Tag {...rest} />
  );
}
